<!-- Template from page -->
<template>
  <section v-if="showNps" class="box-nps">
  <div class="col-xs-12 col-sm-12 col-md-12 content-text-info">
    <h3 class="certa">De 0 a 10, qual a sua nota para a plataforma MarQWeb?</h3>
  </div>
  <div class="col-xs-12 col-sm-12 col-md-12 content-answer">
    <div class="add-note">
      <p v-on:click="addNote(0)" v-bind:class="{'active': dataSendNps.rating === 0}">0</p>
      <p v-on:click="addNote(1)" v-bind:class="{'active': dataSendNps.rating === 1}">1</p>
      <p v-on:click="addNote(2)" v-bind:class="{'active': dataSendNps.rating === 2}">2</p>
      <p v-on:click="addNote(3)" v-bind:class="{'active': dataSendNps.rating === 3}">3</p>
      <p v-on:click="addNote(4)" v-bind:class="{'active': dataSendNps.rating === 4}">4</p>
      <p v-on:click="addNote(5)" v-bind:class="{'active': dataSendNps.rating === 5}">5</p>
      <p v-on:click="addNote(6)" v-bind:class="{'active': dataSendNps.rating === 6}">6</p>
      <p v-on:click="addNote(7)" v-bind:class="{'active': dataSendNps.rating === 7}">7</p>
      <p v-on:click="addNote(8)" v-bind:class="{'active': dataSendNps.rating === 8}">8</p>
      <p v-on:click="addNote(9)" v-bind:class="{'active': dataSendNps.rating === 9}">9</p>
      <p v-on:click="addNote(10)" v-bind:class="{'active': dataSendNps.rating === 10}">10</p>
    </div>
    <div class="client-send-op">
      <label class="nunito">Poderia deixar alguma sugestão de melhoria, crítica ou alguma dificuldade diária no uso da plataforma?</label>
      <textarea v-model="dataSendNps.message"></textarea>
      <button v-on:click="sendNpsNote()" type="submit" class="nunito">
        <span v-if="!loadingSendNps">Enviar</span>
        <div v-else class="loading-btn">
          <div class="spinner-btn">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
            <div class="rect5">
            </div>
          </div>
        </div>
      </button>
    </div>
  </div>
</section>
</template>
<!-- Script from page -->
<script>
  import { SEND_USER_NPS, CHECK_USER_NPS } from "../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../requestConfig";
  import { UTIL_SERVICE } from "../../../utils";
  import swal from "sweetalert";
  import moment from "moment";

  export default {
    name: 'nps-stage',
    data() {
      return {
        sendMsgToAlert: "",
        showNps: false,
        loadingSendNps: false,
        dataSendNps: {
          rating: '',
          message: '',
          userNpsStage: 1,
          eDeviceType: 3
        }
      }
    },
    methods: {
      addNote(value) {
        this.dataSendNps.rating = value;
      },
      sendNpsNote() {
        if (this.dataSendNps.rating >= 0 && this.dataSendNps.rating !== '') {
          this.loadingSendNps = true;
          UTIL_SERVICE.console("DATA SEND:", this.dataSendNps);
          REQUEST_SERVICE.post(SEND_USER_NPS, this.dataSendNps).then((response) => {
            UTIL_SERVICE.console("RESULT SEND_USER_NPS:", response.data);
            window.localStorage.setItem('checkCallNpsByDate', JSON.stringify({date: new Date()}));

            this.sendMsgToAlert = response.data;
            this.showNps = false;
            this.loadingSendNps = false;
          }).catch(reason => {
            this.loadingSendNps = false;
          });
        }
      },
      callNps() {
        REQUEST_SERVICE.get(CHECK_USER_NPS).then((response) => {
          UTIL_SERVICE.console("CHECK_USER_NPS:", response.data);

          if (response.data === 1) {
            window.localStorage.removeItem('checkCallNpsByDate');

            this.showNps = true;
          } else {
            window.localStorage.setItem('checkCallNpsByDate', JSON.stringify({date: new Date()}));
          }
        }).catch(reason => {
        });
      }
    },
    beforeMount(){
      let checkCallNpsByDate = {date: ''};

      if (JSON.parse(window.localStorage.getItem('checkCallNpsByDate'))) {
        checkCallNpsByDate = JSON.parse(window.localStorage.getItem('checkCallNpsByDate'));
      }

      if (checkCallNpsByDate.date) {
        let secondDate = new Date(checkCallNpsByDate.date);
        secondDate = secondDate.setDate(secondDate.getDate() + 15);

        // const countDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
        // const qtdDiffDays = Math.round(Math.abs((new Date(checkCallNpsByDate.date) - secondDate) / countDay));
        if (moment(secondDate).format('DD/MM/YYYY') === moment(checkCallNpsByDate.date).format('DD/MM/YYYY')) {
          this.callNps();
        }
      } else {
        this.callNps();
      }
    },
    watch: {
      sendMsgToAlert : function(val){
        this.$emit('update:msgToAlert', val)
      }
    },
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/vue/views/components/npsStage.vue